import { ExternalLink } from "lucide-react";
import { dateShort } from "@/lib/api";
import { SectionTitle } from "@/components/Bits";

/** Everything from the website inquiry that has no project field of its own. */
export default function OriginalInquiryPanel({ snapshot }) {
  if (!snapshot) return null;
  const rows = [
    ["Submitted", snapshot.submitted_at ? dateShort(snapshot.submitted_at) : null],
    ["They asked for", snapshot.project_type],
    ["Contact", snapshot.name],
    ["Company", snapshot.company],
    ["Email", snapshot.email],
    ["Phone", snapshot.phone],
    ["Location", snapshot.location],
    ["Budget in their words", snapshot.budget],
    ["Project / event date", snapshot.deadline],
    ["Follow-up date", snapshot.follow_up_date],
  ].filter(([, v]) => v);

  return (
    <div className="card-surface p-7" data-testid="original-inquiry-panel">
      <SectionTitle>Original inquiry</SectionTitle>
      {snapshot.idea && (
        <p className="mb-6 whitespace-pre-wrap text-sm leading-relaxed text-ink"
          data-testid="original-inquiry-idea">{snapshot.idea}</p>
      )}
      <dl className="divide-y divide-line border-t border-line">
        {rows.map(([label, value]) => (
          <div key={label} className="flex flex-wrap gap-2 py-3">
            <dt className="w-48 shrink-0 text-xs uppercase tracking-[0.12em] text-fog">{label}</dt>
            <dd className="min-w-0 flex-1 text-sm text-ink [overflow-wrap:anywhere]">{value}</dd>
          </div>
        ))}
      </dl>

      {snapshot.files?.length > 0 && (
        <div className="mt-6">
          <div className="overline mb-3">Inspiration they uploaded</div>
          <div className="space-y-2">
            {snapshot.files.map((f) => (
              <a key={f.url} href={f.url} target="_blank" rel="noreferrer"
                data-testid="original-inquiry-file"
                className="flex items-center gap-2 break-all text-sm text-lime-dark hover:underline">
                <ExternalLink className="h-3.5 w-3.5 shrink-0" strokeWidth={1.5} />
                {f.original_filename || "Attachment"}
              </a>
            ))}
          </div>
        </div>
      )}

      {snapshot.notes?.length > 0 && (
        <div className="mt-6" data-testid="original-inquiry-notes">
          <div className="overline mb-3">Notes from the website admin</div>
          <div className="space-y-3">
            {snapshot.notes.map((n, i) => (
              <div key={i} className="rounded-sm border border-line bg-white px-4 py-3">
                <div className="num text-xs text-fog">{dateShort(n.created_at)} · {n.created_by}</div>
                <p className="mt-1 whitespace-pre-wrap text-sm text-ink">{n.text}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
